import React from 'react';
import PropTypes from 'prop-types';

import {
  Col,
  Datepicker,
  Row,
} from '@folio/stripes/components';
import { Field } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import { FormattedMessage } from 'react-intl';

import { validateDateRange } from '../../../utils';
import {
  DATE_FORMAT,
  TASK_FIELDS,
} from '../../../constants';

const StartDueDateRange = ({
  dueDateTranslationKey,
  startDateTranslationKey,
}) => {
  const dateRangeField = ({ fields }) => {
    return fields.map(name => (
      <Row key={name}>
        <Col
          data-test-start-date
          sm={6}
        >
          <Field
            component={Datepicker}
            dateFormat={DATE_FORMAT}
            label={<FormattedMessage id={startDateTranslationKey} />}
            name={`${name}.${TASK_FIELDS.START_DATE}`}
          />
        </Col>
        <Col
          data-test-due-date
          sm={6}
        >
          <Field name={`${name}.${TASK_FIELDS.DUE_DATE}`}>
            {({ input, meta }) => (
              <Datepicker
                useInput
                usePortal
                dateFormat={DATE_FORMAT}
                error={meta.error}
                id={`${name}.${TASK_FIELDS.DUE_DATE}`}
                input={input}
                label={<FormattedMessage id={dueDateTranslationKey} />}
              />
            )}
          </Field>
        </Col>
      </Row>
    ));
  };

  return (
    <div data-test-date-range>
      <FieldArray
        name="startDueDateRange"
        validate={validateDateRange}
      >
        {dateRangeField}
      </FieldArray>
    </div>
  );
};

StartDueDateRange.propTypes = {
  dueDateTranslationKey: PropTypes.string.isRequired,
  startDateTranslationKey: PropTypes.string.isRequired,
};

export default StartDueDateRange;
